'use client';

import { FC } from 'react';
import { LandingImageSliderStoryblok } from 'storyblok-types';
import { Slide } from 'atoms/Carousel';
import { Container } from 'atoms/Container';
import { Image } from 'atoms/Image/Image';
import { HeadLine } from 'atoms/Typography/Typography';
import { Slider } from 'molecules/Slider';
import { NavigationTypes } from 'molecules/Slider/NavigationButtons';
import { useMediaQuery } from 'modules/mui/hooks';
import styles from './styles.module.css';

export const LandingImageSlider: FC<{ blok: LandingImageSliderStoryblok }> = ({
  blok,
}) => {
  const { isTablet } = useMediaQuery();

  return !blok ? null : (
    <Container
      className={styles.root}
      style={{
        backgroundColor: !isTablet
          ? blok.mobileBackgroundColor.color
          : blok.backgroundColor.color,
      }}
    >
      {blok.title && (
        <HeadLine
          type="m"
          style={{
            color: !isTablet
              ? blok.mobileTitleColor.color
              : blok.titleColor.color,
          }}
        >
          {blok.title}
        </HeadLine>
      )}
      <div className={styles.sliderWrapper}>
        <Slider
          slidesPerView="auto"
          navigationType={NavigationTypes.COMPACT}
          loop={true}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          spaceBetween={16}
          sliderClassName={styles.slider}
          pagination={{ enabled: true }}
          style={{
            color: !isTablet
              ? blok.mobileTitleColor.color
              : blok.titleColor.color,
          }}
        >
          {blok.images.map((image) => (
            <Slide key={image.id} className={styles.slide}>
              <Image
                src={image.filename}
                alt={image?.alt}
                className={styles.img}
              />
            </Slide>
          ))}
        </Slider>
      </div>
    </Container>
  );
};
